<script lang="ts">
	import { QueryClientProvider, type QueryClient } from '@tanstack/svelte-query';
	import type { Snippet } from 'svelte';
	import { sessionEpoch } from '$lib/stores/auth';

	let { client, children }: { client: QueryClient; children: Snippet } = $props();
</script>

<QueryClientProvider {client}>
	{#key $sessionEpoch}
		{@render children()}
	{/key}
</QueryClientProvider>
